<template xmlns="http://www.w3.org/1999/html">
    <div class="bg-black fixed top-0 left-0 w-full h-screen z-10 opacity-40"
         :class="{hidden: !checkedIn.state || checkedIn.self}"></div>
    <div class="fixed top-0 left-0 w-full h-screen z-10 text-6xl text-white flex flex-wrap justify-center items-center"
         :class="{hidden: !checkedIn.state || checkedIn.self}">
        <div class="w-full text-center" style="text-shadow: 1px 1px 10px #000">
            <strong>{{ checkedIn.user.name }}</strong><br/>está a trabalhar neste pedido<br/>
            <button type="button" @click="this.$emit('goBack', false)"
                    class="bg-white mb-5 sm:mb-0 hover:bg-gray-100 mr-2 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow mt-5 text-lg">
                Voltar
            </button>
        </div>
    </div>
    <Head title="Dados"/>
    <h1 class="text-3xl pt-5 font-bold mb-6 text-center lobster text-slate-600 drop-shadow-md">Encomenda nº
        {{ order.value.id }}</h1>
    <button @click="checkIn" type="button"
            class="block bg-white mb-5 sm:mb-0 hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow absolute top-2 right-2">
        {{ checkedIn.buttonText }}
    </button>
    <form @submit.prevent="submitForm">
        <div class="flex flex-wrap items-start justify-center">
            <div class="w-full lg:w-2/6 px-2 sm:px-6 lg:px-8">
                <h3 class="text-xl font-bold text-center lobster text-slate-600 drop-shadow-md">Dados do comprador</h3>
                <div class="overflow-hidden">
                    <div class="px-2 bg-slate-100 border-gray-200">
                        <div id="app">
                            <div id="loader"
                                 class="fixed w-full h-full left-0 top-0 flex justify-center content-center flex-wrap z-10 bg-slate-900/75"
                                 :class="{hidden: loader}">
                                <div class="py-5 bg-white rounded-lg text-center" style="opacity: 0.8;">
                                    <img class="inline-block" src="/storage/img/loader.gif"/>
                                </div>
                            </div>
                            <div :class="{hidden: image.hidden}"
                                 class="transition-all bg-black/50 flex justify-center items-center fixed z-20 top-2 left-2 right-2 bottom-2">
                                <div class="absolute top-5 right-5 z-10"><i
                                    class="fa fa-2x fa-times cursor-pointer text-amber-400"
                                    @click="image.hidden = true"></i></div>
                                <img alt="Image of article" class="md:w-9/12 lg:w-2/3 xl:w-1/2" :src="image.src"/>
                            </div>
                            <div class="flex w-full flex-wrap">
                                <label for="name">Nome de envio</label>
                                <input :disabled="!checkedIn.self" autocomplete="off" v-model="form.name"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="name"
                                       type="text"/>
                                <label for="buyer_name">Nome do titular de pagamento (MBWay/Transf. Bancária)</label>
                                <input :disabled="!checkedIn.self" autocomplete="off"
                                       v-model="form.buyer_name"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="buyer_name"
                                       type="text"/>
                                <label for="email">Email</label>
                                <!-- :required="emailRequired" -->
                                <input :disabled="checkedIn.state === false"
                                       oninvalid="this.setCustomValidity('Inserir email ou telefone')"
                                       oninput="this.setCustomValidity('')"
                                       ref="emailField"
                                       autocomplete="off" v-model="form.email"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="email"
                                       type="email"/>
                                <label for="phone">Telefone</label>
                                <!-- :required="phoneRequired" -->
                                <input :disabled="checkedIn.state === false"
                                       oninvalid="this.setCustomValidity('Inserir email ou telefone')"
                                       oninput="this.setCustomValidity('')"
                                       ref="phoneField"
                                       autocomplete="off" v-model="form.phone"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="phone"
                                       type="tel"/>
                                <label for="address">Morada e código postal</label>
                                <textarea :disabled="!checkedIn.self" v-model="form.address"
                                          class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                          id="address"/>
                                <div class="w-full">
                                    <label for="country">País</label>
                                    <input :disabled="!checkedIn.self" autocomplete="off"
                                           v-model="form.country"
                                           class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                           id="country"
                                           type="text"/>
                                </div>
                                <div class="w-full">
                                    <label for="discounts">Levantamento</label>
                                    <select v-model="form.pickup_type"
                                            class="w-full appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 my-2"
                                            id="pickup_type">
                                        <option value="1">Transportadora</option>
                                        <option value="2">Em Loja</option>
                                    </select>
                                    <p v-if="form.errors.pickup_type" class="text-red-500 text-xs italic">Este campo é
                                        obrigatório</p>
                                </div>
                                <div class="w-full">
                                    <label for="observations">Observações</label>
                                    <textarea :disabled="!checkedIn.self" v-model="form.observations"
                                              class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                              id="observations" rows="5"></textarea>
                                </div>
                                <div class="w-full"
                                     v-if="parseInt(form.status_id, 10) === 3 || parseInt(form.status_id, 10) === 4">
                                    <label for="paid">Pago</label>
                                    <input :disabled="!checkedIn.self" v-model="form.paid"
                                           class="ml-2 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                           id="paid" type="checkbox">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-4/6 pl-2 pr-6 sm:px-6 lg:px-8">
                <h3 class="text-xl font-bold text-center lobster text-slate-600 drop-shadow-md">Peças</h3>
                <form-lines :form="form" :article_codes="article_codes" :checked_in="checkedIn"/>
                <div class="flex flex-wrap mt-5">
                    <div v-for="line in form.order_line"
                         class="w-1/3 border rounded-lg py-5 flex flex-wrap justify-center">
                        <div class="text-center w-full">
                            <span class="font-bold text-xl">{{ line.article.code }}</span>
                        </div>
                        <div class="cursor-pointer inline-block px-2" v-for="img in line.article.images">
                            <img class="rounded-lg"
                                 @click="showImage($event)"
                                 :src="'/storage/img/articles/' + line.article.id + '/' + img.filename.split('.').slice(0, -1).join('.') + '-thumbnail.' + img.filename.split('.').pop() "
                                 :width="50">
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="text-xl mt-5 w-full font-bold text-center lobster text-slate-600 drop-shadow-md mb-5">Preços</h3>
            <div class="w-full px-12 sm:w-1/2 text-center ">
                <label class="text-center" for="shipping-value">Preço dos portes (€):</label>
                <input :disabled="!checkedIn.self" autocomplete="off" required v-model="shippingValue"
                       @change="changedValues()" type="number"
                       step=".01"
                       class="text-center w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       name="shipping_value" id="shipping-value">
                <p v-if="form.errors.shipping_value" class="text-red-500 text-xs italic">Este campo é
                    obrigatório</p>
            </div>
            <div class="w-full px-12 sm:w-1/2 text-center">
                <label class="text-center" for="products-value">Preço das peças (€):</label>
                <input :disabled="!checkedIn.self" autocomplete="off" v-model="productsValue" type="number"
                       disabled step=".01"
                       class="text-center w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       name="products_value" id="products-value">
            </div>
            <div class="w-full sm:w-1/2 px-12 flex justify-center">
                <div class="w-full text-center">
                    <label class="font-bold" for="total-discounts-value">Descontos</label>
                    <input :disabled="!checkedIn.self" autocomplete="off" v-model="totalDiscounts"
                           @change="changedValues()" type="number"
                           step=".01"
                           class="text-center w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           name="total_discounts_value" id="total-discounts-value">
                </div>
            </div>
            <div class="w-full sm:w-1/2 px-12 flex justify-center">
                <div class="w-full text-center">
                    <label class="font-bold" for="total-value">Preço total</label>
                    <input :disabled="!checkedIn.self" autocomplete="off" v-model="totalValue" type="text"
                           disabled
                           class="text-center w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                           name="total_value" id="total-value">
                </div>
            </div>
            <div class="w-full sm:w-1/2 px-12 flex flex-wrap justify-center mt-5">
                <label class="font-bold" for="tracking-number">Código de Rastreio</label>
                <input :disabled="!checkedIn.self" autocomplete="off" v-model="form.tracking_number"
                       type="text"
                       class="text-center w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                       name="tracking_number" id="tracking-number">
            </div>
            <div class="w-full sm:w-1/2 px-12 flex mt-5 flex-wrap items-top justify-center lg:justify-end">
                <div class="w-7/12 flex">
                    <div class="px-2">
                        Criado:
                        <p><strong>{{ order.value.editions[(order.value.editions.length - 1)].by }}</strong><br/>{{ order.value.editions[(order.value.editions.length - 1)].date }}</p>
                    </div>
                    <div class="px-2">
                        Últimas ediçōes:
                        <div v-for="(edition, index) in order.value.editions" :key="index">
                            <div class="border-b-2" v-if="parseInt(index, 10) < (order.value.editions.length - 1)">
                                <strong>{{ edition.by }}</strong><br/>{{ edition.date }}
                            </div>
                        </div>
                    </div>
                </div>
                <button :disabled="!checkedIn.self" type="submit"
                        class="h-10 block bg-white mb-5 sm:mb-0 hover:bg-gray-100 mr-2 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow">
                    Guardar alterações
                </button>
                <button @click="checkIn('checkout');this.$emit('goBack', false)" type="button"
                        class="h-10 block bg-white mb-5 sm:mb-0 hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow">
                    Cancelar
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3';
import {computed, onActivated, onMounted, onUpdated, reactive, ref} from "vue";
import {useForm} from '@inertiajs/inertia-vue3'
import Swal from "sweetalert2";
import FormLines from "@/Components/Order/FormLines";
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        FormLines,
        Head
    },
    emits: ['goBack', 'validar', 'payment', 'deleteOrder', 'doReserve', 'markAs', 'changeStatus'],
    props: ['order', 'article_codes', 'filters', 'user', 'currentStatus'],
    setup(props, {emit}) {
        const currentStatus = decodeURIComponent(window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1));
        const myKey = ref(0);

        const loader = ref(true);

        const productsValue = computed(() => {
            if (props.order.value.order_line !== undefined && props.order.value.order_line !== 'undefined') {
                let pValue = 0;
                const lines = props.order.value.order_line;
                lines.forEach(function (e) {
                    pValue += (e.qtd * e.article.price);
                });
                return Math.round((pValue + Number.EPSILON) * 100) / 100
            }
            return 0;
        });

        let totalDiscounts = ref(0);

        const discounts = JSON.parse(JSON.stringify(props.order.value.discounts));

        if (Array.isArray(discounts)) {
            discounts.forEach(el => {
                const keys = Object.keys(el);
                keys.forEach(key => {
                    totalDiscounts.value += Math.round((parseFloat(el[key]) + Number.EPSILON) * 100) / 100;
                });
            });
        } else if (discounts) {
            totalDiscounts.value += parseFloat(discounts.default);
        }

        const form = useForm({
            ...props.order.value,
            paid: parseInt(props.order.value.status_id, 10) >= 4,
            filters: props.filters,
            status_list: currentStatus
        });

        const submitForm = () => {
            loader.value = true;
            axios.put('/orders', form).then((e,f,g) => {
                // checkedIn.value.buttonText = 'Check IN';
                // checkedIn.value.user = 0;
                // checkedIn.value.state = false;
                // checkedIn.value.self = false;
                // myKey.value++;
                loader.value = false;
                emit('goBack', true)
            }).catch((e) => {
                loader.value = true;
                Swal.fire('Erro', e.response.data, 'error');
                emit('goBack', true)
            });
        }
        form.country = form.country ?? "Portugal";

        let shippingValue = ref(props.order.value.shipping_value);

        let totalValue = computed(() => Math.round((((isNaN(parseFloat(productsValue.value)) ? 0 : parseFloat(productsValue.value)) + (isNaN(parseFloat(shippingValue.value)) ? 0 : parseFloat(shippingValue.value)) - (isNaN(parseFloat(totalDiscounts.value)) ? 0 : parseFloat(totalDiscounts.value))) + Number.EPSILON) * 100) / 100);

        function changedValues(e) {
            form.shipping_value = shippingValue;
            form.totalDiscounts = totalDiscounts;
        }

        // let phoneRequired = null;
        // let emailRequired = null;

        // if ((form.phone === null || form.phone === '') && (form.email === null || form.email === '')) {
        //     phoneRequired = ref(true);
        //     emailRequired = ref(true);
        // } else {
        //     if (form.phone) {
        //         phoneRequired = ref(false);
        //         emailRequired = ref(false);
        //     } else if (form.email) {
        //         phoneRequired = ref(false);
        //         emailRequired = ref(false);
        //     }
        // }

        let image = reactive({
            src: '',
            hidden: true
        });

        function showImage(e) {
            image.src = e.target.src.replace('-thumbnail', '');
            // image.src = e.target.src;
            image.hidden = false;
        }

        const checkedIn = ref({
            user: props.order.value.checkedin_by ?? 0,
            buttonText: props.order.value.checkedin_by === 0 ? 'Check IN' : 'Check OUT',
            state: props.order.value.checkedin_by !== 0,
            self: props.order.value.checkedin_by.id === props.user.id
        });

        const checkIn = (checkout) => {
            loader.value = false;
            axios.put('/orders/checkIn', {
                checkIn: checkout === 'checkout' ? false : !checkedIn.value.state,
                order: props.order.value,
                sort: props.filters.sort,
                search: props.filters.search && props.filters.search.length > 0 ? props.filters.search : null,
                status: props.currentStatus
            }).then(response => {
                checkedIn.value.buttonText = response.data.checkedin_by !== 0 ? 'Check OUT' : 'Check IN';
                checkedIn.value.user = response.data.checkedin_by;
                checkedIn.value.state = response.data.checkedin_by !== 0;
                checkedIn.value.self = response.data.checkedin_by.id === props.user.id;
                myKey.value++;
                loader.value = true;
            }).catch(function (error, e) {
                Swal.fire('Erro, por favor tente mais tarde!', '', 'error')
            });
        }
        return {
            form,
            productsValue,
            totalValue,
            totalDiscounts,
            shippingValue,
            changedValues,
            // emailRequired,
            // phoneRequired,
            loader,
            currentStatus,
            submitForm,
            myKey,
            image,
            showImage,
            checkedIn,
            checkIn
        }
    }
}
</script>
<style>
:root {
    --popper-theme-background-color: #ffffff;
    --popper-theme-background-color-hover: #ffffff;
    --popper-theme-text-color: inherit;
    --popper-theme-border-width: 1px;
    --popper-theme-border-style: solid;
    --popper-theme-border-color: #eeeeee;
    --popper-theme-border-radius: 6px;
    --popper-theme-padding: 16px;
    --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
